<form class="itinerary-model-content-inner" [formGroup]="organizationForm" *ngIf="organizationForm">
  <div class="itinerary-model-content">
    <div class="form-container">
      <!-- Users Details start -->
      <div class="ion-no-padding">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">User Details</ion-title>
      </div>
      <div class="form-container ion-padding-horizontal" formGroupName="organizationContact">
        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">First Name*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationContact.firstName')?.invalid && organizationForm.get('organizationContact.firstName')?.touched }">
                <input class="input" type="text" placeholder="User's First Name" formControlName="firstName">
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Last Name*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationContact.lastName')?.invalid && organizationForm.get('organizationContact.lastName')?.touched }">
                <input class="input" type="text" placeholder="User's Last Name" formControlName="lastName">
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Email*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationContact.email')?.invalid && organizationForm.get('organizationContact.email')?.touched }">
                <input class="input" type="text" placeholder="User's Email" formControlName="email"
                  [readonly]="status === 'SUCCESS'" (blur)="userEmailTabOut($event)">
              </div>
              <div
                *ngIf="organizationForm.get('organizationContact.email')?.hasError('emailTaken') && organizationForm.get('organizationContact.email')?.touched">
                <span class="error-message">Admin user already exists with this email</span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Phone Number*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationContact.personalPhone')?.invalid && organizationForm.get('organizationContact.personalPhone')?.touched }">
                <app-phone-country-input formControlName="personalPhone"></app-phone-country-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Users details end -->

      <!-- Organization Details Start -->
      <div class="ion-no-padding mt-2">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Organization Details</ion-title>
      </div>
      <div class="form-container ion-padding-horizontal" formGroupName="organizationDetails">
        <div class="row" *ngIf="!isUserEditing">
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Organization Name*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.name')?.invalid && organizationForm.get('organizationDetails.name')?.touched }">
                <input class="input" type="text" placeholder="Organization Name" formControlName="name">
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="input-container">
              <label class="label">Organization Type*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.organizationType')?.invalid && organizationForm.get('organizationDetails.organizationType')?.touched }">
                <select formControlName="organizationType" class="input">
                  <option value="" hidden>-- Select Type --</option>
                  <option *ngFor="let type of organizationTypes" [value]="type.key">{{type.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">On Board Date*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.onBoardDate')?.invalid && organizationForm.get('organizationDetails.onBoardDate')?.touched }">
                <app-date-picker [maxDate]="today" formControlName="onBoardDate"></app-date-picker>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">No of Users*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.totalLicense')?.invalid && organizationForm.get('organizationDetails.totalLicense')?.touched }">
                <app-increment-number-input [min]="minimumUsers ? minimumUsers : 1"
                  formControlName="totalLicense"></app-increment-number-input>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <app-address-fields formControlName="groupedAddress"></app-address-fields>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Address Lane 1</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.address1')?.invalid && organizationForm.get('organizationDetails.address1')?.touched }">
                <input class="input" type="text" placeholder="Address Lane 1" formControlName="address1">
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Address Lane 2</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.address2')?.invalid && organizationForm.get('organizationDetails.address2')?.touched }">
                <input class="input" type="text" placeholder="Address Lane 2" formControlName="address2">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Preferred Currency</label>
              <div>
                <select class="input" formControlName="currencyCode">
                  <option *ngFor="let item of currencyLov" [value]="item.key">{{item.name}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Company's Phone Number</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.phone')?.invalid && organizationForm.get('organizationDetails.phone')?.touched }">
                <app-phone-country-input formControlName="phone"></app-phone-country-input>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Company's Website</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.websiteLink')?.invalid && organizationForm.get('organizationDetails.websiteLink')?.touched }">
                <input class="input" type="text" placeholder="Company's Website" formControlName="websiteLink">
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Company's Email Id*</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.email')?.invalid && organizationForm.get('organizationDetails.email')?.touched }">
                <input class="input" type="text" placeholder="Company's Email Id" formControlName="email"
                  [readonly]="organizationForm.get('organizationDetails.senderAccess')?.value === 'SUCCESS'">
              </div>
              <span class="error-message">{{getEmailErrorMessage(organizationForm.get('organizationDetails.email')!)
                }}</span>

            </div>
          </div>

          <div class="col-12">
            <div class="input-container">
              <label class="label">Communication Email Ids</label>
              <div class="email-wrapper input-with-chips">
                <div class="email-chips">
                  <ion-chip class="chipstyle" *ngFor="let emailCtrl of communicationEmails.controls; let i = index">
                    {{ emailCtrl?.value?.email }}
                    <ion-icon name="close-outline" (click)="removeEmail(i)"></ion-icon>
                  </ion-chip>
                  <div
                    [ngClass]="{ 'invalid-input': organizationForm.get('organizationDetails.tempcommunicationEmails')?.invalid && organizationForm.get('organizationDetails.tempcommunicationEmails')?.touched }">
                    <input class="input" type="text" formControlName="tempcommunicationEmails"
                      placeholder="Add another email and press Enter" (keyup.enter)="addEmail($event)">
                    <span
                      class="error-message">{{getEmailErrorMessage(organizationForm.get('organizationDetails.tempcommunicationEmails')!)
                      }}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>






        </div>
      </div>
      <!-- Organization Details End -->

      <!-- Domain setting details start -->
      <div class="ion-no-padding" *ngIf="!isUserEditing">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Domain Settings</ion-title>
      </div>
      <div class="form-container ion-padding-horizontal" formGroupName="domainSettings" *ngIf="!isUserEditing">
        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Domain Provider</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('domainSettings.domainProvider')?.invalid && organizationForm.get('domainSettings.domainProvider')?.touched }">
                <select formControlName="domainProvider" class="input">
                  <option value="" hidden>-- Select Type --</option>
                  <option *ngFor="let type of domainProvidersLov" [value]="type.key">{{type.name}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Domain Name</label>
              <div
                [ngClass]="{ 'invalid-input': organizationForm.get('domainSettings.domainName')?.invalid && organizationForm.get('domainSettings.domainName')?.touched }">
                <input class="input" type="text" placeholder="yourwebsitename.com" formControlName="domainName">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Accoount manager -->
      <div class="ion-no-padding" *ngIf="!isUserEditing">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Account Manager Details</ion-title>
      </div>
      <div class="form-container ion-padding-horizontal pb-2" formGroupName="accountManager" *ngIf="!isUserEditing">
        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Select Account Manager*</label>
              <div [ngClass]="{ 'invalid-input': organizationForm.get('accountManager.accountManagerUserId')?.invalid && organizationForm.get('accountManager.accountManagerUserId')?.touched }">
                <select formControlName="accountManagerUserId" class="input">
                  <option [ngValue]="null" hidden>-- Select User --</option>
                  <option *ngFor="let user of tripmeldAdminUsers" [ngValue]="user.id">{{user.userDetail.firstName}} {{user.userDetail.lastName}} ({{user.userDetail.roleIdentifier}})</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Alternate Contact Number</label>
              <div [ngClass]="{ 'invalid-input': organizationForm.get('accountManager.alternateContactPhoneNumber')?.invalid && organizationForm.get('accountManager.alternateContactPhoneNumber')?.touched }">
                <app-phone-country-input formControlName="alternateContactPhoneNumber"></app-phone-country-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn invisible" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="!organizationId || formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>